export interface RestMsg {
  code: number;
  description: string;
}
